import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CertificadoVerificadoViewModel } from './verificar-certificado.types';

@Injectable()
export class VerificarCertificadoService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    verificarcertificado(params: HttpParams): Observable<CertificadoVerificadoViewModel> {
        return this.http.get<CertificadoVerificadoViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/verificarcertificado/', { params: params }).pipe();
    }

    /*public downloadFileFromSede(idSolicitudEx: number*/ /*DownloadFileFromSedeViewModel*/ /*): Observable<HttpResponse<Blob>> {*/
    //return this.http.post(this.baseUrl + 'api/core/file/downloadFileFromSede', idSolicitudEx, { observe: 'response', responseType: 'blob' })
    //    .pipe();
    downloadFileFromSede(idSolicitudEx: number): Observable<HttpResponse<Blob>> {
        return this.http.post(this.baseUrl + 'api/core/file/downloadFileFromSede', idSolicitudEx, { observe: 'response', responseType: 'blob' }).pipe();
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            //this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
